import "./BoothField.css";

/** Label + input/textarea/select + error, the field pattern used across Booth forms. */
function BoothField({
  id,
  label,
  name,
  type = "text",
  multiline = false,
  rows = 4,
  required = false,
  autoComplete,
  value,
  onChange,
  error,
  options,
}) {
  const errorId = error ? `${id}-error` : undefined;
  const inputClassName = `booth-field-input ${multiline ? "booth-field-input--textarea" : ""} ${
    error ? "booth-field-input--error" : ""
  }`.trim();

  let control;
  if (type === "select") {
    control = (
      <select
        id={id}
        name={name}
        required={required}
        value={value}
        onChange={onChange}
        className={inputClassName}
        aria-invalid={!!error}
        aria-describedby={errorId}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  } else if (multiline) {
    control = (
      <textarea
        id={id}
        name={name}
        rows={rows}
        required={required}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        className={inputClassName}
        aria-invalid={!!error}
        aria-describedby={errorId}
      />
    );
  } else {
    control = (
      <input
        id={id}
        name={name}
        type={type}
        required={required}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        className={inputClassName}
        aria-invalid={!!error}
        aria-describedby={errorId}
      />
    );
  }

  return (
    <div className="booth-field">
      <label className="booth-field-label" htmlFor={id}>
        {label}
      </label>
      {control}
      {error && (
        <span id={errorId} className="booth-field-error">
          {error}
        </span>
      )}
    </div>
  );
}

export default BoothField;
